import { IProject, IAction } from '../../types';
import { GET_PROJECT_SUCCESS } from '../../constants/actions/project.constants';

export default function (
    state: IProject | null = null,
    { payload, type }: IAction,
) {
    switch (type) {
        case GET_PROJECT_SUCCESS:
            return payload as IProject;
        default:
            return state;
    }
}
